import { ColumnType } from "@digitallab/grid-common-frontend-components";
import { OTHER_REASON } from "../../constants";

export const reasonDialogColumnsWithConditionallyRequiredComment = (reasonList: string[]): ColumnType[] => ([
  {
    name: "reason",
    label: "Select reason",
    type: "selectString",
    options: reasonList,
    required: true,
  },
  {
    name: "comment",
    label: 'Comment',
    type: "input",
    conditionalRequired: {
      dependsOnName: "reason",
      condition: (value: string) => {
        return value === OTHER_REASON;
      }
    },
    fieldProps: { maxLength: 80 }
  },
])